var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { app_actions } from "../actions/app_actions";
import { user_actions } from "../actions/user_actions";
import { api_service } from "./../api/api_service";
import { api_urls } from "./../api/api_urls";
class Login_Signup_AsyncActions {
    constructor() {
        this.verifyDealerCode = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.get({ endPoint: api_urls.VERIFY_DEALER_CODE, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.verifyEmail = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.get({ endPoint: api_urls.VALIDATE_EMAIL, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.customerSignup = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.CUSTOMER_SIGNUP, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.signUp = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.SIGNUP, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.login = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.LOGIN, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.logout = () => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.get({ endPoint: api_urls.LOGOUT, showLoader: true });
                        dispatch(app_actions.resetStoreNoReload());
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.forgotPassword = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.FORGOT_PASSWORD, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.forgotPasswordOTPverification = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.VERIFY_OTP, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.signUpEmailOTPverification = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.SIGN_IN_VERIFY_OTP, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.resetPassword = (payload) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({ endPoint: api_urls.RESET_PASSWORD, payLoad: payload, showLoader: true });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.refreshSession = (refreshToken) => {
            return function (dispatch) {
                var _a;
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.post({
                            endPoint: api_urls.REFRESH_TOKEN,
                            payLoad: { RefreshToken: refreshToken }
                        });
                        if (((_a = networkReq.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 403) {
                            return;
                        }
                        const response = networkReq.data;
                        const accessToken = response.data.Token;
                        dispatch(user_actions.sessionRefresh(accessToken));
                        return { accessToken };
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
        this.getVendorConfigDetails = (showLoader = true) => {
            return function (dispatch) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let networkReq = yield api_service.get({ endPoint: api_urls.VENDOR_CONFIG_DETAILS, showLoader });
                        return networkReq;
                    }
                    catch (error) {
                        return error;
                    }
                });
            };
        };
    }
}
export let loginSignup_asyncActions = new Login_Signup_AsyncActions();
